<template>
  <div class="col-lg-12" style="padding:20px;">
    <div class="main-card mb-3 card" style="margin-left:10px;">
      <div class="card-body">
        <h5 class="card-title"  v-if="this.$route.query.type == 'ACTIVE'">정회원
          <div class="sub_title" style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">
            회원목록(ID주문) → 정회원</div></h5>
        <h5 class="card-title"  v-else-if="this.$route.query.type == 'EVENT'">이벤트 회원
          <div class="sub_title" style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">
            회원목록(ID주문) → 이벤트 회원</div></h5>
          <h5 class="card-title" v-else >전체회원
            <div class="sub_title" style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">
              회원목록(ID주문) → 전체회원</div></h5>
        <query-grid :config="config" ref="qg">
          <template #actions>
            <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()"><i class="fa-solid fa-user" style="color:#fff;"></i>&nbsp;신규 회원등록</button>
            <!--button class="btn btn-success ">엑셀저장</button-->
          </template>
           <template #resultactions="props" ><!--추후 제공예정-->

<div style="text-align:right;">
<point-reg-multiple :students="props.checked" ref="childRef" #default="m"  v-if="this.$root.guiPerm == 'ROOT'"><button class="btn blue mini" style="color:#fff;" :data-bs-toggle="m.dataBsToggle" :data-bs-target="m.dataBsTarget" @click="fetchPointChecked()" >학습점수지급</button>
</point-reg-multiple>
<level-multiple :students="props.checked" #default="m"><button class="btn red mini" style="color:#fff;" :data-bs-toggle="m.dataBsToggle" :data-bs-target="m.dataBsTarget" @click="fetchSubscriptionsChecked()" >레벨변경 일괄처리</button>
</level-multiple>
</div>

          </template>
          <template #items="props">
<tr v-for="record in props.records" v-bind:key="record.id" :class="{'table-danger': record.is_deleted}" >
  <td scope="col"><input type="checkbox" v-model="record.checked"></td>
              <td scope="row" style="text-align:center;">{{ record.id }}</td>

              <td style="text-align:center;"><!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                  {{ record.username }}
                  </td>

              <td style="text-align:center;">
                  <Student :student="record" />
                  </td>
              <td style="text-align:center;" v-if="this.$root.guiPerm != 'CLASS' && this.$root.guiPerm != 'ENTERPRISE'" >
                <Business v-if="record.t2" :biz="record.t2" /></td>

                <td style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" />

              </td>
              <td style="text-align:center; padding:15px 0;">{{ record.tutor_name }}</td>
              <td style="text-align:center;"><span v-if="record.type === 'MYPATH'">MY PATH</span>
                <span v-if="record.type === 'ChildU'">ChildU</span>
                <span v-if="record.type === 'ChildUM'">ChildU(M)</span>
              </td>
              <td style="text-align:center;">{{ record.level }}</td>
              <td style="text-align:center;"><span v-if="record.startDate">{{ record.startDate.substr(2, 8) }}</span></td>
              <td style="text-align:center;"><span v-if="record.endDate">{{ record.endDate.substr(2, 8) }}</span></td>
              <td style="text-align:center;"><span v-if="record.endDate"  :style="{'color': getDiff(record.endDate) <= 0 ? 'red': ''}">{{ getDiff(record.endDate) + ' 일' }}</span></td>
              <td style="text-align:center;"><span v-if="record.auto_id_status == '0'" class="btn btn-danger" style="font-size:11px; padding:4px;">미승인</span><template v-else><span
                    class="btn btn-success " style="font-size:11px; padding:4px;">승인</span></template></td>
              <td style="text-align:center;"><span v-if="!record.active_subscription_id" class="btn-gradient red" style="font-size:11px; padding:4px;">미사용</span><template v-else><span
                    v-if="record.ranking_exception" class="btn-gradient cyan" style="font-size:11px; padding:4px;">이벤트</span><span v-else  class="btn-gradient blue" style="font-size:11px; padding:4px; ">정회원</span></template></td>

            </tr>
          </template>

        </query-grid>

        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="studentModal"
          aria-labelledby="myLargeModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="creating">회원등록</h5>
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="!creating">회원수정</h5>
              </div>

              <div class="modal-body" v-if="selData.deleted">
                학생이 삭제되어 더 이상 할 수 있는 작업이 없습니다. 이 창을 닫으세요.
              </div>
              <div class="modal-body" v-else>

                <div>
                  <p class="title" style="font-size:16px;" v-if="!creating">{{selData.hanName}}({{selData.username}}) 회원</p>
                  <div style="display: inline-block; padding: 10px 0 20px; float: right; margin-right: 30px;">


                    <!--button type="button" class="btn btn-primary" style="font-size: 14px!important;"
                      v-if="!creating">학습부여</button-->
                  </div>

                  <div class="card-header" style="clear:both; background:#fff;">
                    <div class="btn-actions-pane-right">
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="tab-content">
                      <div class="" id="tab-eg2-0" role="tabpanel">
                        <p>
                          <table class="table">
                      <colgroup>
                        <col style="width:15%;" />
                        <col style="width:35%;" />
                        <col style="width:15%;" />
                        <col style="width:35%;" />
                      </colgroup>
                            <tbody>
                              <colgroup>
                                <col width="">
                              </colgroup>
                              <tr>
                                <th><i class="fas fa-check-circle"></i>소속</th>
                                <td>
                                  <tree-btn :tree="this.$refs.biz" style="font-size:12px;" class="btn btn-dark" />
                                </td>
                                <th>회원번호</th>
                                <td><span v-if="selData.id">{{selData.id}}</span><span v-else>자동생성</span>
                                </td>
                              </tr>
                              <tr>
                                <th><i class="fas fa-check-circle"></i>아이디</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.username" placeholder="6자 이상의 영문+숫자 조합"  style="width:200px;" />
                                  <!--<button type="button" class="btn btn-warning" @click="doCheck()" v-if="creating"><input type="checkbox" onclick="return false;" v-model="CheckedID" />
                                    중복확인</button>
                                  -->
                                </td>
                                <th><i class="fas fa-check-circle"></i>비밀번호</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.password" placeholder="6자 이상의 영문+숫자 조합" style="width:200px;" />
                                </td>
                              </tr>
                              <!--tr>
                                <th><i class="fas fa-check-circle"></i>추천인</th>
                                <td v-if="!creating">

                                </td>
                                <td v-if="creating">
                                  <input class="hidtype" @input="reonChange($event)" v-model="changedData.recommender" placeholder="학생명이나 아이디를 입력하세요."  style="width:200px;" />
                                  <select class="hidtype" v-model="selectedValue" @change="changeSelect"  v-if="oksearchid">
                                    <option v-for="userlist in userlists" :value="{ id: userlist.id, text: userlist }" v-bind:key="userlist.id">
                                        {{ userlist.name }}({{ userlist.username}})
                                    </option>
                                  </select>
                                </td>
                                <th></th>
                                <td>
                                  <input type="hidden" v-model="changedData.recommenderid"/>
                                </td>
                              </tr-->
                              <tr>
                                <td colspan="4"><strong>※마이패스 상품 학습자의 경우 아이디와 비밀번호는 동일하게 생성※</strong></td>
                              </tr>
                              <tr>
                                <th><i class="fas fa-check-circle"></i>이름</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.hanName" placeholder="홍길동" />
                                </td>
                                <th><i class="fas fa-check-circle"></i>영문명</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.engName" placeholder="Gildong Hong" />
                                </td>
                              </tr>
                              <tr>
                                <th><i class="fas fa-check-circle"></i>성별</th>
                                <td>
                                  <select class="hidtype" v-model="changedData.gender">
                                    <option value="1">남</option>
                                    <option value="2">여</option>
                                  </select>

                                </td>
                                <th><i class="fas fa-check-circle"></i>북클럽</th>
                                <td>
                                  <select class="hidtype"  style="width:165px;"
                                    v-model="changedData.bookclub_status">
                                    <option value="2" :disabled="this.$root.guiPerm != 'ROOT'">승인</option>
                                    <option value="1">상품기본값</option>
                                    <option value="0">차단</option>
                                  </select>
                                </td>
                              </tr>
                              <!--tr>
                                <th><i class="fas fa-check-circle"></i>보카조아</th>
                                <td>
                                  <select class="hidtype" :value="changedData.vocajoa_status || selData.vocajoa_status"
                                    :class="{'hidtype-changed': changedData.vocajoa_status}"
                                    @input="doChange('vocajoa_status', $event.target.value)">
                                    <option value="1">승인</option>
                                    <option value="2">차단</option>
                                  </select>
                                  <button class="btn btn-sm btn-danger" style="display:inline;"
                                    v-if="changedData.vocajoa_status" @click="delete changedData.vocajoa_status"><i
                                      class="bi bi-arrow-counterclockwise"></i></button>
                                </td>
                                <th><i class="fas fa-check-circle"></i>유라클</th>
                                <td>
                                  <select class="hidtype" :value="changedData.uracle_status || selData.uracle_status"
                                    :class="{'hidtype-changed': changedData.uracle_status}"
                                    @input="doChange('uracle_status', $event.target.value)">
                                    <option value="1">승인</option>
                                    <option value="2">차단</option>
                                  </select>
                                  <button class="btn btn-sm btn-danger" style="display:inline;"
                                    v-if="changedData.uracle_status" @click="delete changedData.uracle_status"><i
                                      class="bi bi-arrow-counterclockwise"></i></button>
                                </td>
                              </tr-->
                            </tbody>
                          </table>



                          <table class="table">
                            <colgroup>
                              <col style="width:15%;" />
                              <col style="width:35%;" />
                              <col style="width:15%;" />
                              <col style="width:35%;" />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td style="font-size: 16px; text-align:left;">부가정보</td>
                              </tr>
                              <!--tr>
                                <th>생년월일</th>
                                <td>
                                  <input type="date" class="hidtype" style="width:165px; border:none;"
                                    v-model="changedData.birth_of_day" placeholder="2022-01-01" />
                                </td>
                                <th>학생 전화번호</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.phone" placeholder="010-0000-0000" />
                                </td>
                              </tr-->
                              <tr>
                                <th><i class="fas fa-check-circle"></i>결제자명</th>
                                <td><input class="hidtype" v-model="changedData.parentName" placeholder="홍길순" />
                                </td>
                                <th><i class="fas fa-check-circle"></i>학부모 전화번호</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.parentPhone" placeholder="010-0000-0000" />

                                </td>
                              </tr>
                              <tr>
                                <!--th><i class="fas fa-check-circle"></i>주소</th>
                                <td>
                                  <input class="hidtype" v-model="changedData.address" placeholder="서울 영등포구 국회의사당로 1" />
                                </td-->
                          <th>Pass 기능(언어훈련관 스킵)</th>
                          <td>
                            <select class="hidtype" v-model="changedData.pass_allowed">
                              <option :value="true">허용</option>
                              <option :value="false">차단</option>
                            </select>

                                </td>

                              </tr>
                            </tbody>
                          </table>

                          <span v-if="creating">
                            <div
                              style="text-align:center; margin-top:10px; padding:10px; border:1px solid #f0f0f0; background:#f8f8f8; line-height:30px;">
                              회원가입과 동시에 구매하실 경우 상품(ID)구매 버튼을 눌러주세요.<br /><button class="btn btn-danger "
                                style="margin-left:10px;"><input type="checkbox" v-model="selData.addSubscription"
                                  @click="this.fetchProducts()" />
                                상품(ID)구매</button>
                            </div>
                            <div v-if="selData.addSubscription">
                              <strong>구매 상품 선택</strong>
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>선택</th>

                                    <th>상품명</th>
                                    <th>상품구분</th>
                                    <th>북클럽</th>
                                    <th>보카조아</th>
                                    <th>가격</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="product in products" v-bind:key="product.id">
                                    <td><input type="radio" name="product" v-on:click="selProduct=product" /></td>

                                    <td>{{ product.name }}</td>
                                    <td><span v-if="product.product === 'MYPATH'">MyPath</span>
                                      <span v-if="product.product === 'ChildU'">ChildU</span>
                                      <span v-if="product.product === 'ChildUM'">ChildU(M)</span>
                                    </td>
                                    <td><span v-if="product.bookclubs">O</span>
                                      <span v-if="!product.bookclubs">X</span>
                                    </td>
                                    <td><span v-if="product.vocajoa">O</span>
                                      <span v-if="!product.vocajoa">X</span>
                                    </td>
                                    <td>{{parseInt(product.price).toLocaleString()}}원</td>
                                  </tr>




                                </tbody>
                              </table>
                            </div>
                              <table class="table" style="display:none" id="creatingmode">
                                <colgroup>
                                  <col style="width:12%;" />
                                  <col style="width:4%;" />
                                  <col style="width:20%;" />
                                  <col style="width:20%;" />
                                  <col style="width:18%;" />
                                  <col style="width:30%;" />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <th scope="row"><i class="fas fa-check-circle"></i>레벨</th>
                                    <td> <select class="hidtype" style="width:100px;" v-model="selData.level">
                                        <option disabled>레벨을 선택해 주세요</option>
                                        <template v-if="this.selBiz.study_type != 'ALS'">
                                          <option value="GK">GK</option>
                                          <option value="GK_1">GK_1</option>
                                          <option value="GR1">GR1</option>
                                          <option value="GR2">GR2</option>
                                          <option value="GR3">GR3</option>
                                          <option value="GR4">GR4</option>
                                          <option value="GR5">GR5</option>
                                        </template>
                                        <template v-if="this.selProduct.product === 'ChildUM' ">
                                          <option value="GR6">GR6</option>
                                          <option value="GR7">GR7</option>
                                          <option value="GR8">GR8</option>
                                          <option value="GR9">GR9</option>
                                          <option value="GR10">GR10</option>
                                          <option value="GR11">GR11</option>
                                          <option value="GR12">GR12</option>
                                        </template>
                                        <template v-if="this.selBiz.study_type == 'ALS'">
                                          <option value="Sprout">Sprout</option>
                                          <option value="Blow">Blow</option>
                                          <option value="Flag">Flag</option>
                                          <option value="Wing">Wing</option>
                                          <option value="Dream">Dream</option>
                                          <option value="Royal">Royal</option>
                                        </template>
                                      </select> </td>
                                    <th scope="row"><i class="fas fa-check-circle"></i>시작희망일</th>
                                    <td><input type="date" id="hopeDate3" class="hidtype" v-model="selData.hopeStart"/></td>
                                    <th scope="row"><i class="fas fa-check-circle"></i>결제방법</th>
                                    <td> <select v-model="selData.payMethod" class="form-control" style="font-size:12px;">
                                        <option disabled value="">결제방식을 선택해 주세요</option>
                                        <option value="CARD_ONPG">신용카드(문자전송)</option>
                                        <option value="CASH">현금(입금후 본사로 전화신청)</option>
                                        <option value="CARD_OFFPG" disabled style="display:none;">오프라인 신용카드(개발중)
                                        </option>
                                      </select></td>
                                  </tr>
                                </tbody>
                              </table>
                          </span>



                        </p>
                        <div class="modal-footer flex_center">
                          <button type="button" class="btn btn-primary" @click="doSend()" v-if="creating">학생등록</button>
                        </div>

                      </div>

                    </div>
                  </div>






                </div>
              </div>

            </div>
          </div>
        </div>


      </div>
    </div>
  </div>



  <Tree :key="$route.path" :tree-data="this.$root.businesses" :selectable="['CLASS']" render-button :callback="selectedBiz"
    :selectedNode="{'id': selData.activeBusiness}" ref="biz" />
</template>

<script>
  // @ is an alias to /src

  import Tree from "../components/Tree";
  import treeBtn from "../components/treeBtn";
  import Business from "../components/Business";
  import LevelMultiple from "../components/LevelMultiple";
  import PointRegMultiple from "../components/PointRegMultiple";
  import Student from "../components/detail_pages/Student";
  import IMS from "../components/IMS";
  import QueryGrid from "../components/QueryGrid";
  import axios from "axios";
  import VueCookies from 'vue-cookies';
  export default {
    name: 'Home',
    components: {
      LevelMultiple,
      Tree,
      treeBtn,
      Business,
      Student,
      IMS,
      QueryGrid,
      PointRegMultiple
    },
    mounted() {

      if(this.$route.query.type){
        /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
        this.$refs.qg.pushSetting("status_filter_" + this.$route.query.type, true);
      }
      if(this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL1'){
        this.config.search_fields.push(
          {
            "id": "level_filter",
            "name": "레벨",
            "type": "switch",
            "filter_type": {
                "GK": "GK",
                "GK_1": "GK_1",
                "GR1": "GR1",
                "GR2": "GR2",
                "GR3": "GR3",
                "GR4": "GR4",
                "GR5": "GR5",
                "GR6": "GR6",
                "GR7": "GR7",
                "GR8": "GR8",
                "GR9": "GR9",
                "GR10": "GR10",
                "GR11": "GR11",
                "GR12": "GR12",
                "Sprout": "Sprout",
                "Blow": "Blow",
                "Flag": "Flag",
                "Wing": "Wing",
                "Dream": "Dream",
                "Royal": "Royal"
            }
          }
        )
      }
      else{
        if(this.$root.businesses[0].study_type == 'PLS'){
          this.config.search_fields.push(
            {
              "id": "level_filter",
              "name": "레벨",
              "type": "switch",
              "filter_type": {
                  "GK": "GK",
                  "GK_1": "GK_1",
                  "GR1": "GR1",
                  "GR2": "GR2",
                  "GR3": "GR3",
                  "GR4": "GR4",
                  "GR5": "GR5",
                  "GR6": "GR6",
                  "GR7": "GR7",
                  "GR8": "GR8",
                  "GR9": "GR9",
                  "GR10": "GR10",
                  "GR11": "GR11",
                  "GR12": "GR12"
              }
            }
          )
        }
        else{
          this.config.search_fields.push(
            {
              "id": "level_filter",
              "name": "레벨",
              "type": "switch",
              "filter_type": {
                  "Sprout": "Sprout",
                  "Blow": "Blow",
                  "Flag": "Flag",
                  "Wing": "Wing",
                  "Dream": "Dream",
                  "Royal": "Royal"
              }
            }
          )
        }
      }
      this.config.search_fields.push(
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "아이디/이름/회원번호/튜터명/학원/클래스/담당교사/레벨"
        },
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "start_date": "시작일",
                "end_date": "종료일"
            }
        },
        {
            "id": "auto_id_status",
            "name": "자동연장주문",
            "type": "switch",
            "filter_type": {
                "true": "승인",
                "false": "미승인"
            }
        },
        {
            "id": "is_current_final",
            "name": "연장주문여부",
            "type": "switch",
            "filter_type": {
                "true": "없음",
                "false": "있음"
            }
        },

        {
            "id": "remain_days",
            "name": "잔여일",
            "type": "range_preselect",
            "value_name": "잔여일",
            "filter_type": [7,10,14]
        },
      )
      if(this.$root.guiPerm == 'ROOT'){
        this.config.search_fields.push(
          {
              "id": "search_del",
              "name": "삭제여부",
              "type": "switch",
              "filter_type": {
                  "false": "정상",
                  "true": "삭제",
              }
          }
        )
      }

      if(this.$root.guiPerm == 'CLASS' || this.$root.guiPerm == 'ENTERPRISE'){
        //this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
        this.config.columns.splice(6, 1);
      }

      this.$refs.qg.search();

            this.$watch(
            () => this.$route.query.type,
            function(toQuery, previousQuery){
              // react to route changes...

              this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
              this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
              this.$refs.qg.pushSetting("status_filter_EVENT", false);
              if(toQuery) this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

              this.$refs.qg.search();
            }
          )



    },
    methods: {
      doChange(name, value) {
        if (this.selData[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      changeSelect(){
        this.changedData.recommender = this.selectedValue.text.name + '(' + this.selectedValue.text.username + ')';
        this.changedData.recommenderid = this.selectedValue.id;
      },
      reonChange(event){

        var extras = "?";
        if (event) {

          this.oksearchid = false;
          this.selectedValue = "";
          this.changedData.recommenderid = "";

          if(event.target.value.length > 0){

            ///console.log(event.target.value)

            extras += "source=" + event.target.value;

            axios.get('/searchStudent' + extras).then((response) => {

              if (response.data.error) {
                $.notify({
                  // options
                  message: '데이터를 조회할 수 없습니다. ' + response.data.error
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
              } else {
                this.userlists = response.data.result;
                if(this.userlists){
                  console.log(response.data.result)
                  this.oksearchid = true;
                }
              }
            })
          }
        }
      },
      selectedBiz(biz) {
        this.selBiz = biz;
        this.changedData.activeBusiness = biz.id;
      },
      doCheck() {

        if(!this.changedData.username){
          $.notify(
            {
              message: "사용할 아이디를 입력 해주세요. ",
            },
            {
              type: "danger",
              z_index: 9999,
            }
          );
          return;
        }

        axios
        .get("/students/id_check/" + this.changedData.username)
        .then((response) => {
          if (response.data.error) {
            this.idcheck = false;
            this.CheckedID = false;
            $.notify(
              {
                // options
                message: "중복된 아이디입니다. ",
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.idcheck = true;
            this.CheckedID = true;
            $.notify({
              // options
              message: '사용하실수 있는 아이디입니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }
        });
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        //console.log(this.idcheck)
        /*
        if(!this.idcheck){
          $.notify(
            {
              message: "아이디 중복 체크를 해주세요. ",
            },
            {
              type: "danger",
              z_index: 9999,
            }
          );
          return;
        }
        */
        var data = {};
        if (this.creating) {
          data = {
            ...this.selData,
            ...this.changedData,
            'activeBusiness': this.selBiz.id,
            'product': this.selProduct.id,
            'paymentMethod': this.selData.payMethod,
            'hopeStart': this.selData.hopeStart,
            'level': this.selData.level
          };
        } else {
          data = this.changedData;
        }
        axios({
          method: this.creating ? "post" : "patch",
          url: '/students' + (!this.creating ? "/" + this.selData.id : ""),
          data: data
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.$refs.qg.search()
            $.notify({
              // options
              message: '학생 생성이 처리되었습니다'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            (bootstrap.Modal.getInstance(document.getElementById("studentModal"))).hide();
            if (this.selData.addSubscription) {
              $.notify({
                // options
                message: '아이디 생성을 처리중입니다'
              }, {
                // settings
                type: 'info',
                z_index: 9999
              });

              axios.post('/subscriptions', {
                'student': response.data.id,
                'product': this.selProduct.id,
                'paymentMethod': this.selData.payMethod,
                'hopeStart': this.selData.hopeStart,
                'level': this.selData.level,
                'subject':this.selProduct.subject
              }).then((response) => {
                if (response.data.error) {
                  $.notify({
                    // options
                    message: 'ID 추가 실패: ' + response.data.error
                  }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                  });
                } else {
                  if (confirm("아이디까지 같이 신청이 완료되었습니다. 결제창으로 이동할까요?")) {
                    this.$router.push("/subscriptions?id=" + response.data.id);
                  } else {
                    this.$refs.qg.search()
                    $.notify({
                      // options
                      message: '아이디 신청되었습니다.'
                    }, {
                      // settings
                      type: 'success',
                      z_index: 9999
                    });
                  }

                }


              })


            }


          }


        })


      },
      fetchProducts(source) {
        var extras = "?";
        if (source) {
          extras += "source=" + source.id
        }       
        axios.get('/products' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }
        })

        var now_utc = Date.now() // 지금 날짜를 밀리초로
        // getTimezoneOffset()은 현재 시간과의 차이를 분 단위로 반환
        var timeOff = new Date().getTimezoneOffset()*60000; // 분단위를 밀리초로 변환
        // new Date(now_utc-timeOff).toISOString()은 '2022-05-11T18:09:38.134Z'를 반환
        var today = new Date(now_utc-timeOff).toISOString().split("T")[0];
        document.getElementById("hopeDate3").setAttribute("min", today);

        $('#creatingmode').css('display', 'block');

      },

              fetchSubscriptions(student) {
        var extras = "";
        //this.levelRequest.record = {};
        axios.get('/subscriptions?status_filter=[\"ACTIVE\"]&student=' + student.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            student.subscriptions = response.data.result.filter(x => x.product == 'ChildU');
          }


        })
      },
      fetchSubscriptionsChecked(){
        
        this.$refs.qg.checked.forEach((s) => {
          this.fetchSubscriptions(s);
        })
      },

      fetchPoint(student) {
        var extras = "";
        //this.levelRequest.record = {};
        axios.get('/subscriptions?status_filter=[\"ACTIVE\"]&student=' + student.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            student.subscriptions = response.data.result.filter(x => x.product == 'ChildU');
          }


        })
      },
      fetchPointChecked(){
        this.$refs.childRef.reset();
        this.$refs.qg.checked.forEach((s) => {
          this.fetchPoint(s);
        })
      },





      getDiff(value) {

        var moment = require('moment'); // moment 모듈불러오기

        const diff = moment().diff(value, 'hours');
        const days = Math.floor(diff / 24);
        const hours = diff % 24;

        return -days;

      },
      set_recommender() {
        var record = this.Tsub;
        var new_end_date = prompt("추천인 회원번호를 입력하세요. 예: 71710");

      },
      creatingMode() {
        this.selData = {
          "id": "",
          "activeBusiness": "",
          "username": "",
          "password": "",
          "hanName": "",
          "engName": "",
          "parentName": "",
          "gender": "",
          "bookclub_status": "",
          "vocajoa_status": "",
          "uracle_status": "",
          "birth_of_day": "",
          "phone": "",
          "parentName": "",
          "parentPhone": "",
          "address": "",
          "pass_allowed": false,
          "recommender": "",
          "recommenderid" : "",
          "beta_score" : 0
        };
        this.userlists = [];
        this.creating = true;
        this.changedData = {};
        this.oksearchid = false;
        this.idcheck = false;
        this.CheckedID = false;

      },
      nvl(str){
        if(typeof str == "undefined" || str == null) str = defaultStr ;
         return str ;

      }
    },
    filters: {
      currency(value) {
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    data() {
      return {
        config: {
    "name": "학생 리스트",
    "req_endpoint": "/students",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "businesses",
            "name": "소속선택",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "status_filter",
            "name": "유형",
            "type": "switch",
            "filter_type": {
                "ACTIVE": "정회원",
                "EVENT": "이벤트회원",
                "INACTIVE": "미사용(퇴원)"
            }
        },
        {
            "id": "prod_filter",
            "name": "상품유형",
            "type": "switch",
            "filter_type": {
                "ChildU": "ChildU",
                "MYPATH": "MyPath",
                "ChildUM": "ChildU(M)"
            }
        },
    ],
    "columns": [
              {
            "id": "chkbox",
            "name": "체크",
            "is_check": true
        },
        {
            "id": "id",
            "sortable": true,
            "name": "회원번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "username",
            "sortable": true,
            "name": "아이디",
            "excel_print": v=>{return v.username}
        },
        {
            "id": "hanname",
            "sortable": true,
            "name": "이름",
            "excel_print": v=>{return v.name}
        },
        {
            "id": "gender",
            "name": "성별",
            "not_view": true,
            "excel_print": v=>{return (v.gender == "1" ? '남자' : '여자')}
        },
        {
            "id": "parentPhone",
            "name": "학부모연락처",
            "not_view": true,
            "excel_print": v=>{return v.parentPhone}
        },
        {
            "id": "biz",
            "sortable": true,
            "name": "학원/캠퍼스",
            "excel_print": v=>{return v.t2.name}
        },
                {
            "id": "class",
            "sortable": true,
            "name": "클래스",
            "excel_print": v=>{return v.t1.name}
        },
                        {
            "id": "tutor_name",
            "sortable": true,
            "name": "담당교사",
            "excel_print": v=>{return v.tutor_name}
        },
        {
            "id": "type",
            "sortable": true,
            "name": "학습유형",
            "excel_print": v=>{return v.type || ''}
        },
        {
            "id": "level",
            "sortable": true,
            "name": "레벨",
            "excel_print": v=>{return v.level || ''}
        },
        {
            "id": "start_date",
            "sortable": true,
            "name": "시작일",
            "excel_print": v=>{return v.startDate || ''}
        },
        {
            "id": "end_date",
            "sortable": true,
            "name": "종료일",
            "excel_print": v=>{return v.endDate || ''}
        },
        {
            "id": "remain_days",
            "sortable": true,
            "name": "잔여일",
            "excel_print": v=>{return this.getDiff(v.endDate) || ''}
        },
        {
            "id": "auto_id_status",
            "name": "자동연장주문",
            "sortable": true,
            "excel_print": v=>{return (v.auto_id_status == '1' ? '승인' : '미승인')}
        },
        {
            "id": "status",
            "name": "상태",
            "sortable": true,
            "excel_print": v=>{return (v.active_subscription_id ? (v.ranking_exception ? '이벤트' : '정회원') : '미사용')}
        }
    ],
    disable_init_search: true
},
        selBiz: {
          "name": ""
        },
        subscriptions: [],
        selData: {
          "id": "",
          "activeBusiness": "",
          "username": "",
          "password": "",
          "hanName": "",
          "engName": "",
          "parentName": "",
          "gender": "",
          "bookclub_status": "",
          "vocajoa_status": "",
          "uracle_status": "",
          "birth_of_day": "",
          "phone": "",
          "parentName": "",
          "parentPhone": "",
          "address": "",
          "pass_allowed": false,
          "recommender": "",

        },
        changedData: {

        },
        selProduct: {

        },
        selectedSubscription: {
          id: 0
        },
        products: [],
        creating: true,
        userlists: [],
        oksearchid: false,
        idcheck: false,
        CheckedID: false,
      }
    }
  }
</script>
